




import { Component, Vue } from 'vue-property-decorator'
import loadingGif from '@/assets/img/loading.gif'

@Component
export default class LoadingIndicator extends Vue {
  loadingGif = loadingGif
}
